const DEFAULT_API_BASE_URL = "http://127.0.0.1:8000/api";
const DEFAULT_REFRESH_INTERVAL_MS = 30000;

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

function parseNumber(value: string | undefined, fallback: number): number {
  if (!value) return fallback;
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return fallback;
  return parsed;
}

export const env = {
  apiBaseUrl: trimTrailingSlash(
    import.meta.env.VITE_API_BASE_URL?.trim() || DEFAULT_API_BASE_URL,
  ),
  dashboardRefreshMs: parseNumber(
    import.meta.env.VITE_DASHBOARD_REFRESH_MS,
    DEFAULT_REFRESH_INTERVAL_MS,
  ),
};
